import { render, staticRenderFns } from "./ShoppingCartOutput.vue?vue&type=template&id=e8f87c7c"
import script from "./ShoppingCartOutput.vue?vue&type=script&lang=js"
export * from "./ShoppingCartOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports